import type { SxProps, Theme } from "@mui/material";
import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useNavigate } from "react-router";
import type { MeasureValidReturnType } from "../../../reporting/sv/utilities/isConfigurationValid";
import SkeletonLoader from "../../components/SkeletonLoader";
import { useCurrentTileContext } from "../../contexts/CurrentTileContext";
import { useDashboardContext } from "../../contexts/DashboardContext";
import WidgetNotConfigured from "./WidgetNotConfigured";

interface Props {
  initialized: boolean;
  validity: MeasureValidReturnType;
  sx?: SxProps<Theme>;
}

const SmartViewWidgetViewerWrapper = ({ children, initialized, validity, sx }: PropsWithChildren<Props>) => {
  const navigate = useNavigate();
  const { createEditTileUrl } = useDashboardContext();
  const { tile } = useCurrentTileContext();

  if (!validity.valid) {
    return <WidgetNotConfigured onConfigure={() => navigate(createEditTileUrl(tile.id))} />;
  }

  return (
    <Stack sx={[{ height: "100%", width: "100%", position: "relative" }, ...(Array.isArray(sx) ? sx : [sx])]}>
      {!initialized && (
        <Stack sx={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
          <SkeletonLoader />
        </Stack>
      )}
      <Stack
        sx={{
          height: "100%",
          width: "100%",
          opacity: initialized ? 1 : 0,
          transform: initialized ? "translateY(0)" : "translateY(10px)",
          transition: "opacity 0.4s ease-in-out 0.1s, transform 0.4s ease-in-out 0.1s",
          visibility: initialized ? "visible" : "hidden",
          pointerEvents: initialized ? "auto" : "none",
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default SmartViewWidgetViewerWrapper;
